export const RECOMMEND_URL = 'https://shenzekun-qmusic-api.now.sh/'
export const TOPLIST_URL = 'https://shenzekun-qmusic-api.now.sh/top'
export const SEARCH_URL = 'https://shenzekun-qmusic-api.now.sh/search'
export const LYRICS_URL = 'https://shenzekun-qmusic-api.now.sh/lyrics'
export const HOTKEYS_URL = 'https://shenzekun-qmusic-api.now.sh/hotkey';


// WEBPACK FOOTER //
// ./js/content.js